import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';
import confirmDialog from '@/js/modules/confirm_dialog';

export default class extends Controller {
  static values = { url: String };

  async destroy(event) {
    event.preventDefault();

    if (!(await confirmDialog('Delete this payment?', { button: 'Delete' }))) {
      return;
    }

    const request = new FetchRequest('delete', this.urlValue);
    const response = await request.perform();

    if (response.redirected) {
      window.location.assign(response.response.url);
    }
  }
}
